import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';
import { getters } from '@/modules/core/app/helpers/store';
import { Constant } from '@/modules/core/charts/am5/charts.constants';

export class ChartDrawOption extends BaseDrawOption {
  /**
   * @type {boolean}
   */
  has_legend;

  /**
   * @type {boolean}
   */
  has_tooltip;

  /**
   * @type {boolean}
   */
  depth;

  /**
   * @type {boolean}
   */
  angle;

  /**
   * @type {boolean}
   */
  is_hand_drawn;

  /**
   * @var {string}
   */
  font_color_picker;

  defaultFontColor() {
    return getters.session.usesDarkMode() ? Constant.WHITE_TEXT : Constant.BLACK_TEXT_COLOR;
  }

  defaultBackgroundColor() {
    return getters.session.usesDarkMode() ? Constant.WHITE_TEXT : Constant.GREY;
  }

  constructor(model = {}) {
    super(model);
    this.depth = model.depth !== undefined ? model.depth : 0;
    this.angle = model.angle !== undefined ? model.angle : 0;
    this.is_hand_drawn = model.is_hand_drawn !== undefined ? model.is_hand_drawn : false;
    this.has_tooltip = model.has_tooltip !== undefined ? model.has_tooltip : true;
    this.has_bullets = model.has_bullets !== undefined ? model.has_bullets : true;
    this.has_legend = model.has_legend !== undefined ? model.has_legend : false;
    this.font_color_picker = model.font_color_picker ?? null;
  }
}
